export interface CreditPassed {
  creditPassed?: boolean;
  creditPassedBy: string;
  creditPassedDate?: Date;
}
